import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from 'src/app/config/app.constant';

@Injectable({
    providedIn: 'root'
})
export class MultiFactorAuthenticationService {

    constructor(private cookieService: CookieService) { 
    }

    isMfaSession(url): boolean {
        const isMfaUrl = url.startsWith('/auth');
        const mfaSessionCookie = this.cookieService.get(AppConstants.cookieNames.mfaSession);
        const hasMfaSessionCookie = mfaSessionCookie !== "";
        return isMfaUrl || hasMfaSessionCookie;
    }
}
